/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many UUIDs`)
};

const es_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuántos UUID`)
};

const de_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele UUIDs`)
};

const nl_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel UUIDs`)
};

const fr_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien d'UUID`)
};

const it_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti UUID`)
};

const pt_br2_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos UUIDs`)
};

const pt_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos UUIDs`)
};

const ja_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUIDの個数`)
};

const zh_rg_uuid_count = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID数量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_uuid_count = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_uuid_count(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_uuid_count", locale)
	if (locale === "en") return en_rg_uuid_count(inputs)
	if (locale === "es") return es_rg_uuid_count(inputs)
	if (locale === "de") return de_rg_uuid_count(inputs)
	if (locale === "nl") return nl_rg_uuid_count(inputs)
	if (locale === "fr") return fr_rg_uuid_count(inputs)
	if (locale === "it") return it_rg_uuid_count(inputs)
	if (locale === "pt-BR") return pt_br2_rg_uuid_count(inputs)
	if (locale === "pt") return pt_rg_uuid_count(inputs)
	if (locale === "ja") return ja_rg_uuid_count(inputs)
	return zh_rg_uuid_count(inputs)
};